import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    projects: 0,
    jobs: 0,
    inquiries: 0,
    galleryItems: 0,
    loading: true
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [
          { count: projCount },
          { count: jobsCount },
          { count: inqCount },
          { count: galCount }
        ] = await Promise.all([
          supabase.from('projects').select('*', { count: 'exact', head: true }),
          supabase.from('careers').select('*', { count: 'exact', head: true }).eq('is_active', true),
          supabase.from('requests').select('*', { count: 'exact', head: true }),
          supabase.from('gallery').select('*', { count: 'exact', head: true })
        ]);

        setStats({
          projects: projCount || 0,
          jobs: jobsCount || 0,
          inquiries: inqCount || 0,
          galleryItems: galCount || 0,
          loading: false
        });
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
        setStats(prev => ({ ...prev, loading: false }));
      }
    };

    fetchStats();
  }, []);

  return (
    <div className="p-4 md:p-8 max-w-[1600px] w-full mx-auto space-y-12">
      {/* Greeting Section */}
      <section className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <h2 className="text-3xl md:text-5xl text-white mb-2" style={{ fontFamily: 'Bebas Neue' }}>Welcome back, Administrator.</h2>
          <p className="text-lg text-[#d8c3ad]">Here is the current overview of the HBB0011 portfolio.</p>
        </div>
      </section>

      {/* Summary Widgets Grid */}
      <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Widget 1: Total Projects */}
        <div className="bg-[#1c1b1b] rounded-xl p-6 flex flex-col justify-between h-40 relative overflow-hidden border border-white/5">
          <div className="relative z-10 flex justify-between items-start">
            <span className="text-xs text-[#a08e7a] uppercase tracking-widest font-bold">Total Projects</span>
            <span className="material-symbols-outlined text-[#f59e0b] opacity-70">domain</span>
          </div>
          <div className="relative z-10">
            {stats.loading ? (
              <span className="material-symbols-outlined animate-spin text-[#f59e0b]">sync</span>
            ) : (
              <div className="text-4xl text-white font-bold" style={{ fontFamily: 'Bebas Neue' }}>{stats.projects}</div>
            )}
            <div className="text-sm text-[#d8c3ad] mt-1 font-medium">Active Real Estate Projects</div>
          </div>
        </div>

        {/* Widget 2: Active Job Vacancies */}
        <div className="bg-[#1c1b1b] rounded-xl p-6 flex flex-col justify-between h-40 relative overflow-hidden border border-white/5">
          <div className="relative z-10 flex justify-between items-start">
            <span className="text-xs text-[#a08e7a] uppercase tracking-widest font-bold">Job Vacancies</span>
            <span className="material-symbols-outlined text-[#f59e0b] opacity-70">work</span>
          </div>
          <div className="relative z-10">
            {stats.loading ? (
              <span className="material-symbols-outlined animate-spin text-[#f59e0b]">sync</span>
            ) : (
              <div className="text-4xl text-white font-bold" style={{ fontFamily: 'Bebas Neue' }}>{stats.jobs}</div>
            )}
            <div className="text-sm text-[#d8c3ad] mt-1 font-medium">Currently Hiring Positions</div>
          </div>
        </div>

        {/* Widget 3: Total Inquiries */}
        <div className="bg-[#1c1b1b] rounded-xl p-6 flex flex-col justify-between h-40 relative overflow-hidden border border-white/5">
          <div className="relative z-10 flex justify-between items-start">
            <span className="text-xs text-[#a08e7a] uppercase tracking-widest font-bold">Total Inquiries</span>
            <span className="material-symbols-outlined text-[#f59e0b] opacity-70">mail</span>
          </div>
          <div className="relative z-10">
            {stats.loading ? (
              <span className="material-symbols-outlined animate-spin text-[#f59e0b]">sync</span>
            ) : (
              <div className="text-4xl text-white font-bold" style={{ fontFamily: 'Bebas Neue' }}>{stats.inquiries}</div>
            )}
            <div className="text-sm text-[#f59e0b] mt-1 flex items-center gap-1 font-medium">
              Received via Contact Forms
            </div>
          </div>
        </div>

        {/* Widget 4: Gallery Images */}
        <div className="bg-[#1c1b1b] rounded-xl p-6 flex flex-col justify-between h-40 relative overflow-hidden border border-white/5">
          <div className="relative z-10 flex justify-between items-start">
            <span className="text-xs text-[#a08e7a] uppercase tracking-widest font-bold">Gallery Images</span>
            <span className="material-symbols-outlined text-[#f59e0b] opacity-70">collections</span>
          </div>
          <div className="relative z-10">
            {stats.loading ? (
              <span className="material-symbols-outlined animate-spin text-[#f59e0b]">sync</span>
            ) : (
              <div className="text-4xl text-white font-bold" style={{ fontFamily: 'Bebas Neue' }}>{stats.galleryItems}</div>
            )}
            <div className="text-sm text-[#d8c3ad] mt-1 font-medium">Uploaded Visual Assets</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
